export const ico = {
  constitution: 'university',
  work: 'briefcase',
  justice: 'balance-scale',
  education: 'graduation-cap',
  ecology: 'leaf',
  international: 'globe',
  society: 'heartbeat',
  territory: 'subway',
  culture: 'camera-retro',
  taxation: 'calculator',
};



// WEBPACK FOOTER //
// ../utils.js